import { useDeleteOrganisation } from '@/api/mutations/useDeleteOrganisation';
import { TypedNameDeleteDialog } from '@/new/components/dialogs/typed-name-delete-dialog';

interface DeleteOrganisationDialogProps {
  organisationId: string;
  organisationName: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DeleteOrganisationDialog({
  organisationId,
  organisationName,
  open,
  onOpenChange,
}: DeleteOrganisationDialogProps) {
  const deleteOrganisation = useDeleteOrganisation();

  const handleDelete = () => {
    deleteOrganisation.mutate(
      { organisationId, confirmationName: organisationName },
      { onSuccess: () => onOpenChange(false) },
    );
  };

  return (
    <TypedNameDeleteDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Delete Organisation"
      confirmationName={organisationName}
      inputPlaceholder="Type the organisation name to confirm"
      confirmLabel="Delete Organisation"
      isDeleting={deleteOrganisation.isLoading}
      onConfirm={handleDelete}
    >
      <p>
        This action cannot be undone. This will permanently delete the Organisation and all its users, Matters,
        documents, and data.
      </p>
      <p className="mb-6">
        Deletion runs in the background and may take a long time for Organisations with large Matters.
      </p>
    </TypedNameDeleteDialog>
  );
}
